import { render, staticRenderFns } from "./LabelSlot.vue?vue&type=template&id=6c1f8e96&"
import script from "./LabelSlot.vue?vue&type=script&lang=js&"
export * from "./LabelSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports